import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { buildProviders, KalListComponent, KalSelectionModel } from '@kalidea/kaligraphi';
import { tap } from 'rxjs/operators';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { CustomFormControlAccessWithLoaders } from 'src/app/_core/tools/custom-form-control-access';
import {
    FolderBankListDatasource
} from 'src/app/_shared/dialogs/folder-bank-dialog/folder-bank-list/folder-bank-list.datasource';

import { arrayEmpty } from 'src/app/utils/array.utils';
import { GedCriteresFiltrageGedModelInput, PortailAlbumDto } from 'src/graphql/generated-types';

type folderBankListType = {
    filters: {
        hasExpired: boolean;
        isUnlinked: boolean;
        statusId: number
    },
    searchbar: string
};

@Component({
    selector: 'app-folder-bank-list',
    templateUrl: './folder-bank-list.component.html',
    styleUrls: ['./folder-bank-list.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: buildProviders(FolderBankListComponent),
    standalone: false
})
export class FolderBankListComponent extends CustomFormControlAccessWithLoaders implements OnInit {

    isOpenedFilters = false;

    form: UntypedFormGroup;

    foldersListDatasource: FolderBankListDatasource;

    @ViewChild(KalListComponent) list: KalListComponent<PortailAlbumDto>;

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly graphqlService: GraphqlService,
                private readonly fb: UntypedFormBuilder) {
        super(cdr);
        this.foldersListDatasource = new FolderBankListDatasource(this.graphqlService);
    }

    writeValue(value: PortailAlbumDto): void {
        this.list?.selection?.select(value);
        super.writeValue(value);
    }

    selectFolder($event: KalSelectionModel<PortailAlbumDto>): void {
        if (arrayEmpty($event.added)) {
            return;
        }
        this.notifyUpdate($event.added[0]);
    }

    toggleFilters(): void {
        this.isOpenedFilters = !this.isOpenedFilters;
    }

    private normalizeFilters(formValues: folderBankListType): GedCriteresFiltrageGedModelInput {
        return {
            IsDateDepassee: formValues.filters.hasExpired,
            IsNonLie: formValues.filters.isUnlinked,
            StatutId: formValues.filters.statusId,
            MotCles: formValues.searchbar,
        };
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            searchbar: [],
            filters: [{
                statusId: null,
                hasExpired: false,
                isUnlinked: false
            }]
        });

        this.foldersListDatasource.setFilters(this.normalizeFilters(this.form.value));

        this.watch$ = this.form.valueChanges.pipe(
            tap(formValues => {
                this.foldersListDatasource.setFilters(this.normalizeFilters(formValues));
                this.foldersListDatasource.reset();
            })
        );

        this.watch$ = this.foldersListDatasource.loading$.pipe(
            tap(loading => {
                this.loading = loading;
                this.cdr.markForCheck();
            })
        );
    }

}
